import {Autoplay} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import image1 from '../../assets/block1.png';
import image2 from '../../assets/block2.png';
import image3 from '../../assets/block3.png';
import 'swiper/css';
import 'swiper/css/autoplay';

const InfiniteSlider = ({direction = 'leftToRight'}) => {
	const slides = [image1, image2, image3, image1, image2, image3, image1];
	const isRtl = direction === 'rightToLeft';
	return (
		<div>
			<Swiper
				modules={[Autoplay]}
				autoplay={{
					delay: 0,
					disableOnInteraction: false
				}}
				speed={2000}
				loop={true}
				dir={isRtl ? 'rtl' : 'ltr'}
				allowTouchMove={true}
				breakpoints={{
					320: {slidesPerView: 1, spaceBetween: 10},
					640: {slidesPerView: 2, spaceBetween: 20},
					1024: {slidesPerView: 3, spaceBetween: 30}
				}}>
				{slides.map((slide, index) => (
					<SwiperSlide key={index}>
						<div>
							<img src={slide} alt="image" />
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default InfiniteSlider;
